import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoDrawer, DiscoDrawerHeader, DiscoText } from "@disco-ui"
import TrainingSourcesDrawerContent from "./TrainingSourcesDrawerContent"

export default function TrainingSourcesDrawer() {
  const drawer = useGlobalDrawer("trainingSources")
  const classes = useStyles()

  return (
    <DiscoDrawer
      open={drawer.isOpen}
      onClose={drawer.close}
      size={"large"}
      containerClasses={{
        drawerContainer: classes.drawer,
      }}
    >
      <DiscoDrawerHeader
        title={
          <DiscoText variant={"heading-sm-600"}>
            {drawer.params.kind === "web_crawl" ? "Links" : "Knowledge Bases"}
          </DiscoText>
        }
        onClose={drawer.close}
        className={classes.drawerHeader}
        disableExpand
      />

      {drawer.isOpen && <TrainingSourcesDrawerContent kind={drawer.params.kind} />}
    </DiscoDrawer>
  )
}

const useStyles = makeUseStyles((theme) => ({
  drawerHeader: {
    padding: theme.spacing(2.5, 2.5, 0),
  },
  drawer: {
    padding: theme.spacing(3),
  },
}))
